import { useFormikContext } from 'formik';

import Checkbox from 'components/shared/Checkbox/Checkbox';

const options = [
  { label: 'Portrait', value: 'portrait' },
  { label: 'Landscape', value: 'landscape' }
];

const ExportOrientation = () => {
  const { values, setFieldValue } = useFormikContext();

  if (!values.export_type.includes('pdf')) {
    return;
  }

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Orientation
        <span className="text-danger-400">*</span>
      </label>

      <div className="mt-2 flex flex-wrap gap-4">
        {options?.map((option, idx) => {
          const value = option?.value;

          return (
            <Checkbox
              key={idx}
              data-qa={`checkbox-${value}`}
              isChecked={values?.orientation?.includes(value)}
              handleClick={() => setFieldValue('orientation', value)}
              label={option?.label}
              rounded
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExportOrientation;
